import { cn } from "../../../libs";
import backgroundSrc from "./background.webp";

// Next.js returns StaticImageData ({ src, width, height }); Vite returns a plain string URL
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const bgUrl = ((backgroundSrc as any)?.src ?? backgroundSrc) as string;

interface Props {
  className?: string;
}

export function Background({ className }: Props) {
  return (
    <>
      <div className={cn("absolute inset-0 bg-primary-100", className)} />
      <div
        className={cn("absolute inset-0", className)}
        style={{
          backgroundImage: `url(${bgUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.25,
          filter: "hue-rotate(270deg) saturate(180%)"
        }}
      />
    </>
  );
}
